import React from 'react';
import { Grid, FormControlLabel, Switch, TextField } from '@mui/material';

const SubPartnerInfo = ({ formData, handleChange }) => {
  return (
    <Grid
      container
      spacing={3}
    >
      <Grid
        item
        xs={12}
      >
        <FormControlLabel
          control={
            <Switch
              checked={formData.isSubPartner}
              name="isSubPartner"
              onChange={handleChange}
            />
          }
          label="Is Sub-Partner?"
        />
      </Grid>
      {formData.isSubPartner && (
        <Grid
          item
          xs={12}
        >
          <TextField
            fullWidth
            label="Sub-Partner Of"
            name="subPartnerOf"
            value={formData.subPartnerOf}
            onChange={handleChange}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default SubPartnerInfo;
